import React from 'react';
import { useTranslation } from 'react-i18next';

export const ComponentAlerts = ({ alertType, alertMessageKey }) => {
    const { t } = useTranslation();

    if (!alertType || !alertMessageKey) return null;

    const alertClasses = {
        success: 'alert alert-success',
        warning: 'alert alert-warning',
        error: 'alert alert-error'
    };

    const iconClasses = {
        success: 'check_circle',
        warning: 'warning',
        error: 'cancel'
    };

    return (
        <div className="component-alert">
            <div className={alertClasses[alertType]}>
                <span className="material-icons">{iconClasses[alertType]}</span>
                <p>{t(alertMessageKey)}</p>
            </div>
        </div>
    );
};
